import { schema } from 'normalizr';

// Schemas to normalize the data
export const taskSchema = new schema.Entity('tasks', {}, { idAttribute: 'id' });